import {
  IconItem,
  isLabelIconItem,
  LabelIconItem,
} from "../ContextualMenu/types";
import { Tag } from "./types";
import { FilterTagsProps } from "./FilterTags";

const mapToTag = (item: LabelIconItem | IconItem, filterName?: string): Tag => {
  if (isLabelIconItem(item)) {
    return { value: item.value, label: item.label, filterName };
  }
  return { value: item.value, label: item.value, filterName };
};

export function getSelectedTags({
  values,
  tags,
  items,
  sections,
}: Pick<FilterTagsProps, "values" | "tags" | "items" | "sections">): Tag[] {
  if (sections) {
    return sections
      .map((section) =>
        (section.items ?? [])
          .filter((option) => values?.find((value) => option.value === value))
          .map((tag) => mapToTag(tag)),
      )
      .flat();
  }

  if (!items) {
    return (tags ?? []).filter((tag) =>
      values?.find((value) => tag.value === value),
    );
  }

  return items
    .filter((tag) => values?.find((value) => tag.value === value))
    .map((tag) => mapToTag(tag));
}
